import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createVNode as _createVNode, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bcc08b8c")

_pushScopeId("data-v-bcc08b8c")
const _hoisted_1 = { id: "viewSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = { class: "input-box" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Show component", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "settings-row" }, [
  /*#__PURE__*/_createVNode("p", null, " The View-Component is a Group-Component that can contain multiple components. The first one is the normal component that will be displayed by default. With the View-Change-Action you can make the View-Component display one of the other components. ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.component.drawIndex = $event))
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.component.components, (comp, index) => {
            return (_openBlock(), _createBlock("option", {
              key: index,
              value: index
            }, _toDisplayString(index == 0 ? `Default (${comp.name})` : comp.name), 9, ["value"]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512), [
          [_vModelSelect, _ctx.component.drawIndex]
        ]),
        _hoisted_4
      ])
    ]),
    _hoisted_5
  ]))
})